import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/SynergieJobs - Staging/synergiejobs.be/app/error.tsx");
